module.exports = __webpack_public_path__ + "img/bda90d2.png";